import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import "./Icon.scss";

interface Props{
	name : string,
	size? : number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    name: {},
    size: { default: 1 }
  },
  setup(__props: any) {

let props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["icon", `icon--${_unref(props).name}`]),
    style: _normalizeStyle(`font-size: ${_unref(props).size}px`)
  }, null, 6))
}
}

})